/*@license
Fullscreen Image Zoom and Pan with Jquery
version 3.0.3

Original version by Samil Hazir (https://github.com/saplumbaga)
Version 2.x and .3.x by JM Alarcon (https://github.com/jmalarcon/)

https://github.com/saplumbaga/jquery.pan
https://github.com/jmalarcon/jquery.pan
 */
jQuery.fn.extend({
  pan: function(showRotationControls) {
      var panWrapper = document.createElement("div");
      $(panWrapper).addClass("panWrapper");
      var panImg = document.createElement("img");
      $(panImg).addClass("i").css("position", "absolute");
      var loadingImg = document.createElement("div");
      $(loadingImg).attr("id", "loading").addClass("loading"), $(panWrapper).append(loadingImg);
      var zi = document.createElement("a");
      $(zi).addClass("controls in"), $(panWrapper).append(zi);
      var zo = document.createElement("a");
      if ($(zo).addClass("controls out"), $(panWrapper).append(zo), showRotationControls = 0 != showRotationControls) {
          var rc = document.createElement("a");
          $(rc).addClass("controls rc"), $(panWrapper).append(rc);
          var ra = document.createElement("a");
          $(ra).addClass("controls ra"), $(panWrapper).append(ra)
      }
      var close = document.createElement("a");
      $(close).addClass("controls close"), $(panWrapper).append(close), $(panWrapper).append(panImg), $("body").append(panWrapper);
      var finalSet = $(this).filter(function() {
          if ($(this).attr("data-big")) return !0;
          if ("IMG" != this.tagName) return !0;
          var nW = this.naturalWidth || 0,
              nH = this.naturalHeight || 0,
              w = $(this).outerWidth(),
              h = $(this).outerHeight();
          return w < nW || h < nH
      });

      function __getPointerPos(event, prop) {
          var pos = event[prop];
          return null == pos && (pos = 0, event.touches ? pos = event.touches[0][prop] : event.originalEvent && event.originalEvent.touches && (pos = event.originalEvent.touches[0][prop])), pos
      }

      function panInit(event) {
          event.preventDefault();
          var panImg = $(".panWrapper img.i"),
              panWrapper = $(".panWrapper"),
              w = parseInt(panImg.css("width")),
              h = parseInt(panImg.css("height")),
              vpW = $(panWrapper).width(),
              vpH = $(panWrapper).height(),
              angle = parseInt(panImg.data("rotAngle")) || 0;
          angle % 180 != 0 && (w = [h, h = w][0]);
          var ml = -(w - vpW),
              mt = -(h - vpH),
              scrollHOffset = window.pageXOffset || document.documentElement.scrollLeft,
              scrollVOffset = window.pageYOffset || document.documentElement.scrollTop,
              posOfPointerInViewportX = function(event) {
                  return __getPointerPos(event, "pageX")
              }(event) - scrollHOffset;
          posOfPointerInViewportX < 0 && (posOfPointerInViewportX = 0), (vpW = $(panWrapper).width()) < posOfPointerInViewportX && (posOfPointerInViewportX = vpW);
          var posOfPointerInViewportY = function(event) {
              return __getPointerPos(event, "pageY")
          }(event) - scrollVOffset;
          posOfPointerInViewportY < 0 && (posOfPointerInViewportY = 0), (vpH = $(panWrapper).height()) < posOfPointerInViewportY && (posOfPointerInViewportY = vpH);
          var nl = Math.floor(ml * posOfPointerInViewportX / vpW),
              nt = Math.floor(mt * posOfPointerInViewportY / vpH),
              leftWhenCentered = (vpW - w) / 2,
              topWhencentered = (vpH - h) / 2;
          w < vpW && h < vpH ? (nl = leftWhenCentered, nt = topWhencentered) : w < vpW ? nl = leftWhenCentered : h < vpH && (nt = topWhencentered);
          var tX = 0,
              tY = 0;
          switch (angle % 360) {
              case 0:
                  tX = nl, tY = nt;
                  break;
              case 90:
              case -270:
                  tX = nt, tY = -(w + nl);
                  break;
              case 180:
              case -180:
                  tX = -(w + nl), tY = -(h + nt);
                  break;
              case 270:
              case -90:
                  tX = -h - nt, tY = nl
          }
          panImg.css("transform", "rotate(" + angle + "deg) translate(" + tX + "px," + tY + "px)")
      }
      return finalSet.css("cursor", "zoom-in"), finalSet.click(function(e) {
          var t = $(this),
              big = t.attr("data-big");
          null == big && (big = t.attr("src")), $("#loading").addClass("loading");
          var imgViewer = $(".panWrapper img.i").attr("src", "");
          return $(".panWrapper").show(), imgViewer.css("width", "auto").attr("src", big).on("load", function() {
              $("#loading").removeClass("loading"), panInit(e)
          }), !1
      }), 
      $(zi).click(function(e) {
          var panImg = $(".panWrapper img.i");
          var panImgWidth = parseInt(1.2 * parseInt(panImg.css("width")));
          if(panImgWidth < 600){
            panImgWidth = 600;
          }else if(panImgWidth > 3000){
            panImgWidth = 3000;
          }
          panImg.css("width", panImgWidth), panInit(e)
          // panImg.css("width", parseInt(1.2 * parseInt(panImg.css("width"))), panInit(e)
      }), 
      $(zo).click(function(e) {
          var panImg = $(".panWrapper img.i");
          var panImgWidth = parseInt(parseInt(panImg.css("width")) / 1.2) + 1;
          if(panImgWidth < 600){
            panImgWidth = 600;
          }else if(panImgWidth > 3000){
            panImgWidth = 3000;
          }
          panImg.css("width", panImgWidth), panInit(e)
          // panImg.css("width", parseInt(parseInt(panImg.css("width")) / 1.2) + 1), panInit(e)
      }), showRotationControls && ($(rc).click(function(e) {
          var panImg = $(".panWrapper img.i").first(),
              angle = parseInt(panImg.data("rotAngle")) || 0;
          angle = (angle + 90) % 360, panImg.css({
              transform: "rotate(" + angle + "deg)"
          }), panImg.data("rotAngle", angle), panInit(e)
      }), $(ra).click(function(e) {
          var panImg = $(".panWrapper img.i").first(),
              angle = panImg.data("rotAngle") || 0;
          angle = (angle - 90) % 360, panImg.css({
              transform: "rotate(" + angle + "deg)"
          }), panImg.data("rotAngle", angle), panInit(e)
      })), $(close).click(function(e) {
          $(".panWrapper").fadeOut("slow", function() {
              var panImg = $(".panWrapper img.i").first();
              panImg.data("rotAngle", 0), panImg.css({
                  transform: "rotate(0)"
              })
          })
      }), $(panImg).click(function() {
          $(close).click()
      }), $(panWrapper).on("mousemove touchmove", function(e) {
          panInit(e)
      }), $("body").keydown(function(e) {
          27 == e.keyCode && $(close).click()
      }), $(panWrapper).mousewheel(function(wheelEvent) {
          0 < wheelEvent.deltaY ? $(zo).click() : $(zi).click(), panInit(wheelEvent)
      }), finalSet
  }
}),
function() {
  var _addEventListener, support, prefix = "";
  window.addEventListener ? _addEventListener = "addEventListener" : (_addEventListener = "attachEvent", prefix = "on"), void 0 !== document.onmousewheel && (support = "mousewheel");
  try {
      WheelEvent("wheel"), support = "wheel"
  } catch (e) {}

  function _addWheelListener(elem, eventName, callback, useCapture) {
      elem[_addEventListener](prefix + eventName, "wheel" == support ? callback : function(originalEvent) {
          var event = {
              originalEvent: originalEvent = originalEvent || window.event,
              target: originalEvent.target || originalEvent.srcElement,
              type: "wheel",
              deltaMode: "MozMousePixelScroll" == originalEvent.type ? 0 : 1,
              deltaX: 0,
              delatZ: 0,
              pageX: originalEvent.pageX,
              pageY: originalEvent.pageY,
              preventDefault: function() {
                  originalEvent.preventDefault ? originalEvent.preventDefault() : originalEvent.returnValue = !1
              }
          };
          return "mousewheel" == support ? (event.deltaY = -.025 * originalEvent.wheelDelta, originalEvent.wheelDeltaX && (event.deltaX = -.025 * originalEvent.wheelDeltaX)) : event.deltaY = originalEvent.detail, callback(event)
      }, useCapture || !1)
  }
  support = support || "DOMMouseScroll", window.addWheelListener = function(elem, callback, useCapture) {
      _addWheelListener(elem, support, callback, useCapture), "DOMMouseScroll" == support && _addWheelListener(elem, "MozMousePixelScroll", callback, useCapture)
  }, $.fn.mousewheel = function(handler) {
      return this.each(function() {
          window.addWheelListener(this, handler, !0)
      })
  }
}(jQuery);
//# sourceMappingURL=jquery.pan.min.js.map